<template>
  <div class="basket-header">
    <img src="../assets/img/line_between_left.png"/>
    <span class="basket-header__text"><slot /></span>
    <img src="../assets/img/line_between_right.png"/>
  </div>
</template>

<script>
export default {
  name: 'BasketHeader',
};
</script>

<style lang="scss" scoped>
.basket-header {
  margin-bottom: 30px;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 1);
  font-size: 18px;
  position: relative;
  top: 30px;
  font-weight: bold;
  display: flex;
  align-items: center;
  &__text {
    position: relative;
    margin: 0 10px;
    // min-width: 220px;
    text-align: center;
    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 13px;
      background: rgba(230, 162, 60, 0.2);
      border-radius: 6px;
      left: 0;
      bottom: 3px;
    }
  }
  img {
    width: 226px;
    height: 10px;
  }
}
</style>
